module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloudy-c649990abeebd542cee47003e77c4f52.svg";